import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../utils/Methods";
import { IDS } from "../../utils/IDS";


export const GetAllDepositNotReceived = createAsyncThunk(
    "support/GetAllDepositNotReceived/get",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Support.Deposit}?name=${filter?.name || ""}&status=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const DepositeNotReceivedStatusChange = createAsyncThunk(
    "support/DepositeNotReceivedStatusChange/post",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Support.Deposit}/${id}`, data);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GetAllWithdrawQuery = createAsyncThunk(
    "support/GetAllWithdrawQuery/get",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Support.Withdraw}?name=${filter?.name || ""}&status=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const WithdrawQueryStatusChange = createAsyncThunk(
    "support/WithdrawQueryStatusChange/post",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Support.Withdraw}/${id}`, data);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GetAllIFSCQuery = createAsyncThunk(
    "support/GetAllIFSCQuery/get",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Support.IFSC}?name=${filter?.name || ""}&status=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const IFSCQueryChange = createAsyncThunk(
    "support/IFSCQueryChange/post",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Support.IFSC}/${id}`, data);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GetAllChangePasswordQuery = createAsyncThunk(
    "support/GetAllChangePasswordQuery/get",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Support.ChangePassword}?name=${filter?.name || ""}&status=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const ChangePasswordStatusChange = createAsyncThunk(
    "support/ChangePasswordStatusChange/post",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Support.ChangePassword}/${id}`, data);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GetAllChangeBankNameQuery = createAsyncThunk(
    "support/GetAllChangeBankNameQuery/get",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Support.ChangeBankName}?name=${filter?.name || ""}&status=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const ChangeBankNameChange = createAsyncThunk(
    "support/ChangeBankNameChange/post",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Support.ChangeBankName}/${id}`, data);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GetAllModifyBankInfoQuery = createAsyncThunk(
    "support/GetAllModifyBankInfoQuery/get",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Support.ModifyBankInfo}?name=${filter?.name || ""}&status=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const ModifyBankInfoChange = createAsyncThunk(
    "support/ModifyBankInfoChange/post",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Support.ModifyBankInfo}/${id}`, data);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GetAllModifyUpiQuery = createAsyncThunk(
    "support/GetAllModifyUpiQuery/get",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Support.ModifyUpi}?name=${filter?.name || ""}&status=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const ModifyUpiChange = createAsyncThunk(
    "support/ModifyUpiChange/post",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Support.ModifyUpi}/${id}`, data);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GetAllAddUSDTAddressQuery = createAsyncThunk(
    "support/GetAllAddUSDTAddressQuery/get",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Support.AddUSDTAddress}?name=${filter?.name || ""}&status=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const AddUSDTAddressQueryChange = createAsyncThunk(
    "support/AddUSDTAddressQueryChange/post",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Support.AddUSDTAddress}/${id}`, data);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GetAllChangeUSDTAddressQuery = createAsyncThunk(
    "support/GetAllChangeUSDTAddressQuery/get",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Support.ChangeUSDTAddress}?name=${filter?.name || ""}&status=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const ChangeUSDTAddressChange = createAsyncThunk(
    "support/ChangeUSDTAddressChange/post",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Support.ChangeUSDTAddress}/${id}`, data);

            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GetAllActivityBonusQuery = createAsyncThunk(
    "support/GetAllActivityBonusQuery/get",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Support.ActivityBonus}?name=${filter?.name || ""}&status=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// ─── Games Thunks ─────────────────────────────────────────────────────────────

export const GetAllwinningHistory = createAsyncThunk(
    "admin/color-predicition/all-winning-history",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Games.Color_Prediction}/winning-history?name=${filter?.name || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetSummaryData = createAsyncThunk(
    "admin/color-predicition/summary-data",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Games.Color_Prediction}/summary_data?name=${filter?.name || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// ─── Helper to build repeated pending/fulfilled/rejected cases ────────────────

const buildSupportCases = (builder, thunk) => {
    builder
        .addCase(thunk.pending, (state) => {
            state.status = IDS.SLICESTATUS.Loading;
        })
        .addCase(thunk.fulfilled, (state, action) => {
            state.status = IDS.SLICESTATUS.Succeeded;
            state.data = action.payload?.data?.data || [];
            state.current_page = action.payload?.data?.current_page || IDS.PAGE;
            state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
            state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
            state.total = action.payload?.data?.total || IDS.TOTAL;
        })
        .addCase(thunk.rejected, (state, action) => {
            state.status = IDS.SLICESTATUS.Failed;
            state.error = action.payload;
        });
};

// ─── Slice ────────────────────────────────────────────────────────────────────

export const Slice = createSlice({
    name: "color_redictions",
    initialState: {
        data: [],
        summary_data: {},
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        // Support thunks
        buildSupportCases(builder, GetAllDepositNotReceived);
        buildSupportCases(builder, GetAllWithdrawQuery);
        buildSupportCases(builder, GetAllIFSCQuery);
        buildSupportCases(builder, GetAllChangePasswordQuery);
        buildSupportCases(builder, GetAllChangeBankNameQuery);
        buildSupportCases(builder, GetAllModifyBankInfoQuery);
        buildSupportCases(builder, GetAllModifyUpiQuery);
        buildSupportCases(builder, GetAllAddUSDTAddressQuery);
        buildSupportCases(builder, GetAllChangeUSDTAddressQuery);
        buildSupportCases(builder, GetAllActivityBonusQuery);

        // Games thunks
        buildSupportCases(builder, GetAllwinningHistory);

        builder
            .addCase(GetSummaryData.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSummaryData.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.summary_data = action.payload?.data || [];
            })
            .addCase(GetSummaryData.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

export const { } = Slice.actions;

export default Slice.reducer;